import React from 'react';
import styles from './Advt.module.css';

import { useGetParams } from '../../hooks/useGetParams';

const Advt = React.memo(() => {
  const { title, qrCode, sizeQR } = useGetParams();

  return (
    <>
      {qrCode && (
        <div className={styles.advtBlock}>
          <div className={styles.title}>{title}</div>

          <div className={styles.qrItem}>
            <div
              className={styles.qr}
              style={{ height: `${sizeQR}rem`, width: `${sizeQR}rem` }}>
              <img src={qrCode} alt="QR" />
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default Advt;
